"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CallAction() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="calltoaction" data-nav="light" className="bg-background py-16 md:py-20 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.35,
        ease: [0.25, 0.46, 0.45, 0.94]
      }} className="relative mx-auto max-w-4xl overflow-hidden rounded-2xl bg-primary text-primary-foreground px-6 py-12 text-center shadow-md sm:px-12 sm:py-16 md:px-16 md:py-20">
          <div className="relative z-10 mx-auto max-w-2xl space-y-4">
            <h2 className="text-3xl font-bold tracking-tight text-primary-foreground sm:text-4xl md:text-5xl">
              Ready to arrange an appointment?
            </h2>
            <p className="text-base leading-relaxed text-primary-foreground/90 sm:text-lg">
              {"Get in touch and we'll help you choose the right option."}
            </p>
            <div className="pt-4">
              <Button asChild size="lg" className="btn-primary bg-background text-primary hover:bg-secondary hover:text-primary shadow-sm">
                <Link to="https://align-physiotherapy.uk3.cliniko.com/bookings?business_id=1869864670421067946&practitioner_id=1869864668449745369&appointment_type_id=1869864670219741836">
                  <span>Book an Appointment</span>
                  <ArrowRight className="size-4 ml-1.5" aria-hidden="true" />
                </Link>
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}